import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  height: 240,
  width: 250,
  backgroundColor: theme.palette.common.white,
  borderRadius: 20,
  border: `1px solid ${theme.palette.grey[500]}`,
  margin: theme.spacing(8),
  padding: theme.spacing(16, 10),
  flexDirection: 'column',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    height: 'auto',
    width: 'auto',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    margin: theme.spacing(4, 0),
    padding: theme.spacing(6),
  },
}));

export const StyledLogoContainer = styled(Flex)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: 60,
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.main,
  [theme.breakpoints.down('md')]: {
    marginRight: theme.spacing(9),
  },
}));

export const StyledLogo = styled('img')(({ theme }) => ({
  width: 24,
  height: 24,
  objectFit: 'contain',
}));

export const Title = styled(Text)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    marginBottom: 0,
  },
}));

export const Subtitle = styled(Text)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  [theme.breakpoints.up('md')]: {
    overflow: 'hidden',
    whiteSpace: 'wrap',
  },
  [theme.breakpoints.down('md')]: {
    marginTop: 0,
  },
}));
